module.exports = __webpack_public_path__ + "static/media/ac.2ffd52a7.png";